import { render, staticRenderFns } from "./AdminFans.vue?vue&type=template&id=1c6203e2&scoped=true"
import script from "./AdminFans.vue?vue&type=script&lang=js"
export * from "./AdminFans.vue?vue&type=script&lang=js"
import style0 from "./AdminFans.vue?vue&type=style&index=0&id=1c6203e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6203e2",
  null
  
)

export default component.exports